import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class IdentitySecurityService {

  constructor(private http: HttpClient) { }

  async changePassword(userId: string, passwordData: any) {
    return this.http.put(environment.identityUrl + "/api/User/" + userId + "/Security/ChangePassword", passwordData);
  }

  async getAuthenticationMethods(userId: string){
    return this.http.get(environment.identityUrl + "/api/User/" + userId + "/Security/GetAuthenticationMethods");
  }

  async checkPassword(userId: string, password: string){
    return this.http.post(environment.identityUrl + "/api/User/" + userId + "/Security/CheckPassword", { "Password": password });
  }

  async disableTwoFactor(userId: string){
    return this.http.post(environment.identityUrl + "/api/User/" + userId + "/Security/Disable2FA", {});
  }

  async enableAuthenticatorQR(userId: string){
    return this.http.get(environment.identityUrl + "/api/User/" + userId + "/Security/EnableAuthenticator"); 
  }

  async enableAuthenticator(userId: string, authenticatorData: any){
    return this.http.post(environment.identityUrl + "/api/User/" + userId + "/Security/EnableAuthenticator", authenticatorData); 
  }

  async generateRecoveryCodes(userId: string) {
    return this.http.get(environment.identityUrl + "/api/User/" + userId + "/Security/GenerateRecoveryCodes"); 
  }

  async startSecurityKeyRegistration(userId: string){
    return this.http.post(environment.identityUrl + "/api/User/" + userId + "/Security/StartSecurityKeyRegistration", {}); 
  }

  async completeSecurityKeyRegistration(userId: string, data: any){
    return this.http.post(environment.identityUrl + "/api/User/" + userId + "/Security/CompleteSecurityKeyRegistration", data); 
  }

  async deleteSecurityKey(userId: string){
    return this.http.delete(environment.identityUrl + "/api/User/" + userId + "/Security/RemoveSecurityKey"); 
  }
}